import {
  Box,
  Button,
  Divider,
  TextInput,
  Typography,
} from "@strapi/design-system";
import { message, Form, Input } from "antd";
import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { emailConfirmation, getProfile } from "../util/API";
import { useTranslation } from "react-i18next";
import { setUserInfo } from "../redux/action/app";
import { useDispatch } from "react-redux";

const EmailConfirmation = ({ lng = "vi" }) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const [confirmation, setConfirmation] = useState(null);
  const [is_nominatee, setIsNominatee] = useState(false);
  const [nominator_id, setNominatorId] = useState(null);
  const [password, setPassword] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState(null);
  const [email, setEmail] = useState(null);

  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();

  const [form] = Form.useForm();

  useEffect(() => {
    localStorage.clear();
    if (searchParams.has("email")) {
      setEmail(searchParams.get("email").replace(" ", "+"));
      form.setFieldValue("email", searchParams.get("email").replace(" ", "+"));
    }

    if (!searchParams.has("confirmation")) {
      //Alert thông báo confirmation in valid
      messageApi.open({
        type: "error",
        content: t("str_email_comfirmation.invalid"),
      });
    } else {
      setConfirmation(searchParams.get("confirmation"));
    }

    if (searchParams.has("nominator_id")) {
      setNominatorId(searchParams.get("nominator_id"));
    }

    if (searchParams.has("is_nominatee")) {
      setIsNominatee(true);
    } else {
      const submit = async () => {
        const response = await emailConfirmation({
          confirmation: searchParams.get("confirmation"),
        });

        if (response.status === 200) {
          const { user, jwt } = response.data;
          localStorage.setItem("token", jwt);
          localStorage.setItem("user", user);
          await getUserInfo();

          if (lng === "en") navigate(`/nomination/profile`);
          else navigate(`/nomination/ho-so`);
        }

        if (response.status === 400) {
          if (lng === "en") navigate(`/nomination/login`);
          else navigate(`/nomination/dang-nhap`);
        }
      };
      submit();
    }
  }, []);

  useEffect(() => {
    if (lng) {
      i18n.changeLanguage(lng);
    }
  }, [lng]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const checkValid = isValid();
    if (!checkValid) {
      messageApi.open({
        type: "error",
        content: t("str_fill_in_all_info"),
      });
      return;
    }

    try {
      const response = await emailConfirmation({
        confirmation,
        password,
        is_nominatee,
        nominator_id,
      });

      if (response.status === 200) {
        const { user, jwt } = response.data;
        localStorage.setItem("token", jwt);
        localStorage.setItem("user", user);
        await getUserInfo();
        if (lng === "en") navigate(`/nomination/profile`);
        else navigate(`/nomination/ho-so`);
      }

      if (response.status === 400) {
        if (lng === "en") navigate(`/nomination/login`);
        else navigate(`/nomination/dang-nhap`);
      }
    } catch (error) {}
  };

  //#region Validation
  const isValid = () => {
    if (password === "") return false;
    return true;
  };

  const getUserInfo = async () => {
    try {
      const response = await getProfile();
      dispatch(setUserInfo(response.data));
    } catch (error) {
      console.error(error);
      // TODO: Handle error while fetching profile
    }
  };
  //#endregion

  return (
    <div>
      {contextHolder}
      <div className="login-form-wrapper">
        <Box paddingBottom={2}>
          <Typography variant="alpha" style={{ textAlign: "center" }}>
            {t("str_email_comfirmation.title")}
          </Typography>
        </Box>

        <Divider />

        <Form
          layout="vertical"
          name="basic"
          style={{
            maxWidth: 600,
          }}
          onFinish={handleSubmit}
          autoComplete="off"
          form={form}
        >
          <Form.Item
            label="Email"
            name="email"
            onChange={(e) => setEmail(e.target.value)}
            disabled={true}
            value={email}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label={t("str_password")}
            name="password"
            onChange={(e) => setPassword(e.target.value)}
            rules={[
              {
                required: true,
                message: t("str_required_password"),
              },
            ]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item
            name="confirm"
            label={t("str_confirm_password")}
            onChange={(e) => setConfirmPassword(e.target.value)}
            dependencies={["password"]}
            hasFeedback
            rules={[
              {
                required: true,
                message: t("str_please_confirm_password"),
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(t("str_password_not_match")));
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item>
            <Button color="primary" type="submit" onClick={handleSubmit}>
              {t("str_email_comfirmation.submit")}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default EmailConfirmation;

